/* External */
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

/* Storage */
import { deleteRequest } from '../storage/requests';

export default function useDeleteUnusedRequest(requestId: string) {
  const prevRequestId = useRef(requestId);
  const dispatch = useDispatch();

  useEffect(() => {
    if (prevRequestId.current) {
      dispatch(deleteRequest(prevRequestId.current));
    }
    prevRequestId.current = requestId;
  }, [dispatch, requestId]);

  useEffect(() => () => {
    if (prevRequestId.current) {
      dispatch(deleteRequest(prevRequestId.current));
    }
  }, [dispatch, requestId]);
}
